// extracted by mini-css-extract-plugin
export default {"dangerSectionGrid":"U24Qs","dangerSectionField":"AKyqV"};